import React from 'react';
import { Text } from '@/components/typography';
import WhitePaper from '@/components/elevation/WhitePaper/WhitePaper';
import { useTranslations } from 'next-intl';

const CardCurrencyInfo = () => {
  const t = useTranslations('Pacote');
  return (
    <WhitePaper>
      <Text size="sm">
        <strong>*</strong>{' '}
        {t('Valor indicado em moeda estrangeira, convertido em reais de acordo com a cotação do dia do pagamento')}.
      </Text>
    </WhitePaper>
  );
};

export default CardCurrencyInfo;
